import { NgModule } from '@angular/core';

import { MwFilterPipe } from './filter.pipe';
import { MwHoursToTimeDurationPipe } from './hours-to-time-duration.pipe';
import { MwMinutesToTimeDurationPipe } from './minutes-to-time-duration.pipe';
import { MwHighlightPipe } from './highlight.pipe';

@NgModule({
  declarations: [
    MwFilterPipe,
    MwHoursToTimeDurationPipe,
    MwMinutesToTimeDurationPipe,
    MwHighlightPipe,
  ],
  imports: [],
  exports: [
    MwFilterPipe,
    MwHoursToTimeDurationPipe,
    MwMinutesToTimeDurationPipe,
    MwHighlightPipe,
  ],
})
export class MwPipesModule {}
